import * as React from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'

import { cn } from '@/lib/utils'

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List> & {
    tabSize?: 'sm' | 'md' | 'lg'
  }
>(({ className, tabSize = 'md', ...props }, ref) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-9',
    lg: 'h-10',
  }

  return (
    <TabsPrimitive.List
      className={cn(
        cn(
          'inline-flex items-center justify-center rounded-md',
          'bg-gray-100 p-1 text-gray-600'
        ),
        sizeClasses[tabSize],
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & {
    tabSize?: 'sm' | 'md' | 'lg'
  }
>(({ className, tabSize = 'md', ...props }, ref) => {
  const sizeClasses = {
    sm: 'h-7 px-3 text-xs',
    md: 'h-8 px-4 text-sm',
    lg: 'h-9 px-6 text-sm',
  }

  return (
    <TabsPrimitive.Trigger
      className={cn(
        cn(
          'inline-flex items-center justify-center whitespace-nowrap',
          'rounded-md font-medium transition-all',
          'focus-visible:outline-none focus-visible:ring-1',
          'focus-visible:ring-ring disabled:pointer-events-none',
          'disabled:opacity-50 data-[state=active]:bg-white',
          'data-[state=active]:text-gray-900 data-[state=active]:shadow-sm'
        ),
        sizeClasses[tabSize],
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    className={cn(
      cn(
        'mt-2 focus-visible:outline-none focus-visible:ring-1',
        'focus-visible:ring-ring'
      ),
      className
    )}
    ref={ref}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
